import { mdiArrowLeft } from '@mdi/js';
import HeaderButton from '../components/layout/HeaderButton';
import Layout from '../components/layout/Layout';
import { useNavigate } from 'react-router-dom';
import ReceiveQRScanner from '../features/receive/ReceiveQRScanner';
import { useState } from 'react';

/**
 * @description Wallet QR scanner page component
 * @return {React.FC}
 */
const WalletQRScanner: React.FC = () => {
  const navigate = useNavigate();
  const [camera, setCamera] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  return (
    <Layout
      showFooter={!camera}
      title={showSuccess ? 'Proof Successful!' : 'Receive Invitations'}
      leftButton={
        <HeaderButton
          icon={mdiArrowLeft}
          onPress={() => (camera ? setCamera(false) : navigate('/'))}></HeaderButton>
      }>
      <ReceiveQRScanner
        camera={camera}
        setCamera={setCamera}
        showSuccess={showSuccess}
        setShowSuccess={setShowSuccess}
      />
    </Layout>
  );
};

export default WalletQRScanner;
